/**
 * 토스 결제창에서 돌아오는 곳 (#244)
 *
 *   /pay/{order_id}/done?paymentKey=…   콘솔이 저장한 금액으로 승인 → 서비스로
 *   /pay/{order_id}/fail?code=…         실패로 기록 → 서비스로
 *
 * 주소에 붙어 오는 amount 는 쓰지 않는다. 승인 금액은 서버가 주문에서 꺼낸다.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { GatewayCard, GatewaySpinner } from '@/components/billing/gateway/GatewayCard';
import { useRequireLogin } from '@/hooks/auth/useRequireLogin';
import { paymentOrderAPI } from '@/services/apis/paymentOrderAPI';
import { getErrorMessage } from '@/utils/errorUtils';

const PaymentOrderResultPage: React.FC<{ mode: 'done' | 'fail' }> = ({ mode }) => {
  const { orderId = '' } = useParams();
  const [params] = useSearchParams();
  const loggedIn = useRequireLogin();
  const [error, setError] = useState('');
  // 승인은 한 번만 보낸다. StrictMode 의 두 번 실행으로 두 번 보내지 않게 한다
  const sent = useRef(false);

  useEffect(() => {
    if (!loggedIn || sent.current) return;
    sent.current = true;
    const request = mode === 'done'
      ? paymentOrderAPI.confirm(orderId, params.get('paymentKey') ?? '')
      : paymentOrderAPI.fail(orderId, params.get('code') ?? 'UNKNOWN', params.get('message') ?? '');
    request
      .then(({ redirect_to }) => window.location.replace(redirect_to))
      .catch((e) => setError(getErrorMessage(e, mode === 'done' ? '결제를 승인하지 못했습니다.' : '결제 결과를 처리하지 못했습니다.')));
  }, [loggedIn, mode, orderId, params]);

  if (error) {
    return (
      <GatewayCard title={mode === 'done' ? '결제를 승인하지 못했습니다' : '결제를 처리하지 못했습니다'}>
        <p className="mb-6 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</p>
        <Button className="w-full" onClick={() => window.location.replace(`/pay/${encodeURIComponent(orderId)}`)}>
          결제 화면으로 돌아가기
        </Button>
      </GatewayCard>
    );
  }
  return (
    <GatewayCard title="결제">
      <GatewaySpinner message={mode === 'done' ? '결제를 승인하는 중입니다. 창을 닫지 마세요.' : '서비스로 돌아가는 중입니다.'} />
    </GatewayCard>
  );
};

export default PaymentOrderResultPage;
